var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"aside-menu-item",class:{ active: _vm.active, logout: _vm.materialIcon === 'logout' }},[_c('div',[(_vm.materialIcon)?_c('i',{staticClass:"material-symbols-outlined"},[_vm._v(_vm._s(_vm.materialIcon))]):_vm._e(),_vm._t("icon")],2),_c('span',{staticClass:"title__small"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }